(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_optionDeleteController',Delivery_optionDeleteController);

    Delivery_optionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Delivery_option'];

    function Delivery_optionDeleteController($uibModalInstance, entity, Delivery_option) {
        var vm = this;

        vm.delivery_option = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Delivery_option.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
